import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  fetchHotelBrands as fetchHotelBrandsApi,
  fetchHotelById as fetchHotelByIdApi,
  fetchHotels as fetchHotelsApi,
  fetchStayCities as fetchStayCitiesApi,
  fetchStaysHome as fetchStaysHomeApi,
  searchStays as searchStaysApi,
} from "@/services/api/stays";

const initialState = {
  home: null,
  hotels: [],
  hotelDetail: null,
  brands: [],
  cities: [],
  searchResults: [],
  loading: false,
  error: null,
};

export const fetchStaysHome = createAsyncThunk(
  "stays/fetchHome",
  async (params, { rejectWithValue }) => {
    try {
      return await fetchStaysHomeApi(params);
    } catch (error) {
      return rejectWithValue(error.message || "Failed to load stays home");
    }
  }
);

export const fetchSearchStays = createAsyncThunk(
  "stays/search",
  async (payload, { rejectWithValue }) => {
    try {
      return await searchStaysApi(payload);
    } catch (error) {
      return rejectWithValue(error.message || "Failed to search stays");
    }
  }
);

export const fetchHotels = createAsyncThunk(
  "stays/fetchHotels",
  async (params, { rejectWithValue }) => {
    try {
      return await fetchHotelsApi(params);
    } catch (error) {
      return rejectWithValue(error.message || "Failed to load hotels");
    }
  }
);

export const fetchHotelById = createAsyncThunk(
  "stays/fetchHotelById",
  async (id, { rejectWithValue }) => {
    try {
      return await fetchHotelByIdApi(id);
    } catch (error) {
      return rejectWithValue(error.message || "Failed to load hotel");
    }
  }
);

export const fetchHotelBrands = createAsyncThunk(
  "stays/fetchBrands",
  async (params, { rejectWithValue }) => {
    try {
      return await fetchHotelBrandsApi(params);
    } catch (error) {
      return rejectWithValue(error.message || "Failed to load hotel brands");
    }
  }
);

export const fetchStayCities = createAsyncThunk(
  "stays/fetchCities",
  async (params, { rejectWithValue }) => {
    try {
      return await fetchStayCitiesApi(params);
    } catch (error) {
      return rejectWithValue(error.message || "Failed to load stay cities");
    }
  }
);

const staysSlice = createSlice({
  name: "stays",
  initialState,
  reducers: {
    clearStaysError(state) {
      state.error = null;
    },
    resetStaysState() {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchStaysHome.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchStaysHome.fulfilled, (state, action) => {
        state.loading = false;
        state.home = action.payload;
      })
      .addCase(fetchStaysHome.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(fetchSearchStays.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchSearchStays.fulfilled, (state, action) => {
        state.loading = false;
        state.searchResults = action.payload;
      })
      .addCase(fetchSearchStays.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(fetchHotels.fulfilled, (state, action) => {
        state.hotels = action.payload;
      })
      .addCase(fetchHotelById.fulfilled, (state, action) => {
        state.hotelDetail = action.payload;
      })
      .addCase(fetchHotelBrands.fulfilled, (state, action) => {
        state.brands = action.payload;
      })
      .addCase(fetchStayCities.fulfilled, (state, action) => {
        state.cities = action.payload;
      });
  },
});

export const { clearStaysError, resetStaysState } = staysSlice.actions;
export default staysSlice.reducer;
